import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Section } from "@/components/layout/Section";
import { StratoButton } from "@/components/common/StratoButton";
import { Reveal } from "@/components/common/Reveal";
import { FINAL_CTA } from "@/content/homeContent";

export const FinalCta = () => {
  return (
    <Section id="final-cta-section" tone="light" className="py-24 lg:py-36">
      <Reveal>
        <div className="mx-auto max-w-3xl text-center">
          <p className="strato-micro text-strato-blue">{FINAL_CTA.microLabel}</p>
          <h2 className="mt-5 font-display text-4xl font-medium leading-[1.08] tracking-[-0.02em] text-strato-graphite sm:text-5xl lg:text-[3.5rem]">
            {FINAL_CTA.headline}
          </h2>
          <p className="mx-auto mt-5 max-w-[48ch] text-lg leading-[1.6] text-muted-foreground">
            {FINAL_CTA.description}
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <StratoButton
              as={Link}
              to="/preventivo"
              data-testid="final-start-quote-button"
              className="px-7 py-4 text-[15px]"
            >
              {FINAL_CTA.primaryCta}
              <ArrowRight className="h-4 w-4" />
            </StratoButton>
            <StratoButton
              as={Link}
              to="/contatti"
              variant="secondary"
              data-testid="final-contact-button"
              className="px-7 py-4 text-[15px]"
            >
              {FINAL_CTA.secondaryCta}
            </StratoButton>
          </div>
          <p className="strato-micro mt-8 text-muted-foreground">
            NESSUN IMPEGNO · VALUTAZIONE TECNICA UMANA
          </p>
        </div>
      </Reveal>
    </Section>
  );
};
